module.exports = __webpack_public_path__ + "img/mancha-illustration.81fcbfd9.svg";